import * as React from "react";

import { ILoginPage } from "@montana/models/generated/cms.interface";
import { LoginModule } from "@montana/shared/login-module";
import { Container } from "@montana/shared/container";
import { InView } from "@montana/shared/in-view";
import { DynamicBlocks } from "@montana/blocks/dynamic-blocks.component";

export const LoginPage: React.FC<ILoginPage> = React.memo(({
    blocks,
    title,
    subtitle,
    loginButtonText,
    usernamePlaceholder,
    passwordPlaceholder,
    loginErrorMessage,
    rememberMeText,
}: ILoginPage): JSX.Element => (
    <Container>
        <InView singleFire>
            {({ inView, ref }): JSX.Element => (
                <section ref={ref} className={`login-page${inView ? ' login-page--visible' : ''}`}>
                    <div className="login-page__title-wrapper">
                        <h1 className="login-page__title display-3">{title}</h1>
                    </div>

                    <div className="login-page__module">
                        <div className="login-page__subtitle">
                            {subtitle}
                        </div>
                        <LoginModule
                            loginButtonText={loginButtonText}
                            usernamePlaceholder={usernamePlaceholder}
                            passwordPlaceholder={passwordPlaceholder}
                            loginErrorMessage={loginErrorMessage}
                            rememberMeText={rememberMeText}
                            autoFocus={false}
                        />
                    </div>
                </section>
            )}
        </InView>

        <section className="login-page__blocks-section">
            <DynamicBlocks blocks={blocks} />
        </section>

    </Container>
));
